import * as Yup from 'yup';
import { Motive } from '../../../../../../shared/types/systemConfiguration/motives';

export const initialValues: Motive = {
    name: '',
    class: '',
    code: '',
    extra: '',
    parent: [],
    active: true,
};

export const validationSchema = (id?: string) =>
    Yup.object({
        name: Yup.string().required('El nombre es obligatorio'),
        extra: Yup.string().when([], {
            is: () => Boolean(id),
            then: (schema) => schema.required('La descripción es obligatoria'),
            otherwise: (schema) => schema.notRequired(),
        }),
        parent: Yup.array()
            .of(
                Yup.object({
                    id: Yup.string().required(),
                    name: Yup.string().required(),
                })
            )
            .min(1, 'El tipo PQR es obligatorio')
            .required('El tipo PQR es obligatorio'),
    });
